import { render, staticRenderFns } from "./MangeGiftProgramHeaderActions.vue?vue&type=template&id=148f67fe&scoped=true"
import script from "./MangeGiftProgramHeaderActions.vue?vue&type=script&lang=js"
export * from "./MangeGiftProgramHeaderActions.vue?vue&type=script&lang=js"
import style0 from "./MangeGiftProgramHeaderActions.vue?vue&type=style&index=0&id=148f67fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f67fe",
  null
  
)

export default component.exports